<div class="mb-3 d-flex align-items-center justify-content-center">
  <button
    [disabled]="disabled"
    class="btn btn-primary btn-shadow d-block w-100"
    type="submit"
    (click)="addPromotionToCart()"
  >
    {{ "TRANSLATE.SAVE" | translate }}
  </button>
</div>
